/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
import useSelect from "~components/Form/hooks/useSelect";
import { db } from "~/db/db";
import prepareForOptions from "~services/utils/prepareForOptions";
import useAreasVendaVendedor from "./useAreasVendaVendedor";

const useEscritorioVenda = (formikRef, equipeSelect, editFormSelect = false, opt = {}) => {
  const escritorioSelect = useSelect("escritorioVenda");
  const [escritorio, setEscritorio] = useState(0);
  const [escritorioEdit, setEscritorioEdit] = useState(null);
  const [fila, setFila] = useState(null);
  const [escritorios, setEscritorios] = useState([]);

  const { escritoriosIds } = useAreasVendaVendedor(formikRef);
  useEffect(() => {
    const fetchEscritorios = async () => {
      const escritoriosArray = [];
      await db.escritoriosVenda.each((esc) => {
        escritoriosArray.push(esc);
      });
      setEscritorios(escritoriosArray);
    };

    fetchEscritorios();
  }, []);



useEffect(() => {
  if (editFormSelect &&  opt) {
    const { escritorioVendaId } = opt || {};

    if (escritorioVendaId && escritorioVendaId !== 0) {
      const fetchEscritorio = async () => {
        const result = await db.escritoriosVenda
          .where("id")
          .equals(escritorioVendaId)
          .first();

        setEscritorioEdit(result ? [result] : null);
      };

      fetchEscritorio();
    } else {
      setEscritorioEdit(null);
    }
  }
}, [editFormSelect, opt]);



  const escritoriosFiltrados = useMemo(() => {
    if (!escritoriosIds?.length) return [];

    let filtrados = escritorios.filter((esc) => escritoriosIds.includes(esc.id));

    const idEscritorio = equipeSelect?.value?.escritorioVendaId ?? null;

    if (idEscritorio) {
      filtrados = filtrados.filter((esc) => esc.id === idEscritorio);
    }

    return filtrados;
  }, [escritorios, escritoriosIds, equipeSelect?.value?.escritorioVendaId]);

  const optionsEscritorio = useMemo(
    () => prepareForOptions(escritoriosFiltrados, ["nome"], "id"),
    [escritoriosFiltrados]
  );


  const optionsEscritorioedit = useMemo(
    () => escritorioEdit?.length > 0 ? prepareForOptions(escritorioEdit, ["nome"], "id") : null,
    [escritorioEdit]
  );


  useEffect(() => {
  if (editFormSelect && optionsEscritorioedit?.length === 1) {
    const escritorio = optionsEscritorioedit[0];
    if (escritorio) {
      onChangeEscritorio(escritorio);
    }
  }
}, [editFormSelect, optionsEscritorioedit]);

  const escritoriosObjId = useMemo(
    () =>
      createEscritorioObj({
        key: "id",
        data: escritoriosFiltrados,
        prefix: "key-",
      }),
    [escritoriosFiltrados]
  );
  const escritoriosObjCodigo = useMemo(
    () => createEscritorioObj({ key: "codigo", data: escritoriosFiltrados }),
    [escritoriosFiltrados]
  );
  const escritoriosObjNome = useMemo(
    () => createEscritorioObj({ key: "nome", data: escritoriosFiltrados }),
    [escritoriosFiltrados]
  );

  function createEscritorioObj({ key = "codigo", data = [], prefix = "" }) {
    if (Array.isArray(data)) {
      return data.reduce((acc, cur) => {
        acc[`${prefix}${cur[key]}`] = cur;
        return acc;
      }, {});
    }
    return {};
  }

  useEffect(() => {
    if (fila && optionsEscritorio?.length > 0) {
      SetSelectEscritorio(fila);
    }
  }, [optionsEscritorio, fila]);

  function onChangeEscritorio(e) {
    escritorioSelect.upDateValue(e.value);
    escritorioSelect.upDateDefaultValue(e || "");
    formikRef?.current?.setFieldValue("escritorioVendaId", e.value);

    setTimeout(() => formikRef?.current?.setFieldTouched("escritorioVendaId", true));
    setEscritorio(e.value);
  }

  function SetSelectEscritorio(id) {
    if (optionsEscritorio?.length > 0) {
      const escritorio = optionsEscritorio.find((esc) => esc.value === id);
      if (escritorio) onChangeEscritorio(escritorio);
      setFila(null);
    } else {
      setFila(id);
    }
  }

  useEffect(() => {
    if (optionsEscritorio.length === 1) {
      SetSelectEscritorio(optionsEscritorio[0].value);
    }
  }, [optionsEscritorio]);

  function clearEscritorio() {
    escritorioSelect.upDateValue(null);
    escritorioSelect.upDateDefaultValue(null);

    formikRef?.current?.setFieldValue("escritorioVendaId", null);
    formikRef?.current?.setFieldTouched("escritorioVendaId", false);

    setEscritorio(0);
    setFila(null);
  }

  return {
    optionsEscritorio,
    escritorios: escritoriosFiltrados,
    onChangeEscritorio,
    clearEscritorio,
    SetSelectEscritorio,
    escritorio,
    escritorioSelect,
    escritoriosObjId,
    escritoriosObjCodigo,
    escritoriosObjNome,
    optionsEscritorioedit
  };
};

export default useEscritorioVenda;
